import { getSharedKiddoAxios } from "./httpClient";

const getApi = () => getSharedKiddoAxios();

export const QuizListSubject = async () => {
  const api = await getApi();
  const response = await api.get("/read/QuizListSubject");
  return response.data;
};
